<template>
  <div class="page bg flex">
    <app-header title="评价" class="flex0">
      <i slot="back" class="back"></i>
      <div class="right absolute" @click="sub" slot="right" v-if="score">发布</div>
    </app-header>
    <div class="main flex1 overflow-y-auto">
      <p class="center fs14 bg_white color_666">---- 请您对本次服务做出评价 ----</p>
      <star class="bg_white center pt5" :click="true" size="big" @change="change"></star>
      <div class="center bg_white fs14 pt5 text">{{text}}&nbsp;</div>
      <div class="tag bg_white" v-if="score>=6">
        <span v-for="i in tag" class="color_666" :class="[tagtext.indexOf(i.dicValue)>=0?'cover':'']"
              @click="handler(i)">{{i.dicValue}}</span>
      </div>
      <div class="center pb5 bg_white fs12" v-else-if="score>0">
        遇到什么问题？请向我们反馈 <br>
        点击<span class="color_main" @click="showKefu">联系客服</span>
      </div>

      <div class="content bg_white mt5 relative" v-if="score">
        <div class="total fs14 color_666 absolute">{{content.length}}/200</div>
        <div class="color_666">您可以填写具体评价（选填）</div>
        <textarea maxlength="200" v-model="content" class="fs14 " placeholder=""></textarea>
      </div>
    </div>
    <kefu ref="kefu"></kefu>
    <msg ref="msg"></msg>
  </div>
</template>
<script>
  import {RATE} from "../../../lib/config";
  import Star from '../../../plugins/star'
  import Kefu from '../../../plugins/user/kefu'
  import {scrollIntoViewMixin} from "../../../lib/mixin";


  export default {
    data() {
      return {
        content: "", score: 0, tag: [], tagtext: []
      }
    },
    computed: {
      text() {
        if (this.score) return RATE[this.score / 2 - 1];
        return ""
      }
    },
    mixins: [scrollIntoViewMixin],
    created() {
      this.getList();
    },
    methods: {
      showKefu() {
        this.$refs.kefu.show();
      },

      handler(i) {
        let {tagtext} = this,
          index = tagtext.findIndex(r => r == i.dicValue);
        console.log(i, index);
        if (index < 0) {
          this.tagtext.push(i.dicValue)
        } else {
          this.tagtext.splice(index, 1);
        }
      },

      change(index) {
        this.score = (index) * 2;
      },

      async sub() {
        let {content, score, $route: {query}} = this;
        let form = {content, score, consultId: query.consultId};

        if (form.content && form.content.length > 200) {
          this.$refs.msg.show('评价内容不能超过200个字');
          return false
        }


        if (this.tagtext && score > 4 && this.tagtext.length > 0) {
          if (form.content) {
            form.content = this.tagtext.join(',') + ',' + form.content;
          } else {
            form.content = this.tagtext.join(',');
          }
        }
        let loading = this.$weuijs.loading("加载中...");
        let {code} = await this.$http('nethos.consult.info.comment', form);
        loading.hide();
        if (code == 0) {
          this.$weuijs.toast('评价成功', {
            callback: () => {
              this.$router.replace({
                path: `/team/consult/${query.consultId}`
              });
            }
          })
        }
      },

      async getList() {
        let loading = this.$weuijs.loading("加载中...");
        let {code, list} = await this.$http('nethos.system.dictionary.list', {dicName: '评价'});
        loading.hide();
        if (code == 0) this.tag = list;
      }
    },
    components: {Star, Kefu},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../../../common/public.scss';

  .pt5 {
    padding-top: 5px;
  }

  .pb5 {
    padding-bottom: 5px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .page {
    flex-direction: column;
  }

  .star {
    letter-spacing: 10px;
  }

  p {
    padding-top: 50px;
  }

  .text {
    color: orange;
  }

  .tag {
    padding: 15px;
    span {
      display: inline-block;
      border: 0.5px solid $borderColor;
      border-radius: 5px;
      margin: 0 5px 5px;
      padding: 3px 5px;
      &.cover {
        color: #ffffff;
        background-color: $mainColor;
      }
    }
  }

  .content {
    padding: 10px;
    .total {
      right: 10px;
      bottom: 10px;
    }
    textarea {
      min-height: 150px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/myConsult/comment.vue